import React from 'react';
import styled from 'styled-components';
import { media } from 'helpers/MediaHelper';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

import BackArrowIcon from '@material-ui/icons/ArrowBackIosOutlined';

const StyledBackButton = styled.button`
  color: ${colors.ULTRAMARINE_BLUE};
  cursor: pointer;
  background: none;
  border: none;
  position: absolute;
  top: 10%;
  left: 7%;
  display: flex;
  align-items: center;

  ${media.mobile`
    top: 3%;
  `};
`;

const WizardControls = ({ closeWizard, goBack, pageIndex }) => {
  const moveBackward = () => {
    if (pageIndex === 0) {
      return closeWizard();
    }
    return goBack();
  };

  return (
    <StyledBackButton onClick={moveBackward}>
      <BackArrowIcon />
      {getTranslatedString('back')}
    </StyledBackButton>
  );
};

export default WizardControls;
